function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M2.47228933,2.05133456 C3.78563761,0.740205408 5.80779672,0.455698865 7.43193483,1.35354001 C9.05607294,2.25138116 9.89065567,4.11512554 9.47887289,5.92464987 C9.06709011,7.73417419 7.50821117,9.05325262 5.6554908,9.15988559 C3.80277044,9.26651856 2.10284785,8.13499983 1.48617822,6.38466789 C1.40971081,6.16762567 1.52366921,5.9296891 1.74071144,5.85322169 C1.95775366,5.77675428 2.19569023,5.89071269 2.27215764,6.10775491 C2.76549334,7.50802046 4.12543141,8.41323544 5.60760771,8.32792907 C7.089784,8.24262269 8.33688715,7.18735995 8.66631337,5.73974049 C8.99573959,4.29212103 8.32807342,2.80112553 7.02876293,2.08285261 C5.72945243,1.36457969 4.11172515,1.59218492 3.0519915,2.64985851 L3.0519915,2.64985851 L1.88466667,3.74533333 L3.33333459,3.7462114 C3.5378845,3.7462114 3.70800824,3.89360737 3.7432882,4.08798171 L3.75000126,4.16287807 C3.75000126,4.39299671 3.56345324,4.57954473 3.33333459,4.57954473 L3.33333459,4.57954473 L0.833334594,4.57954473 C0.831289095,4.57954473 0.829247039,4.57952999 0.827208525,4.57950062 C0.816268476,4.57934241 0.805170736,4.5787411 0.794109267,4.57769942 C0.777654057,4.57617832 0.761668369,4.57371853 0.746008444,4.57037891 C0.74030204,4.56911199 0.734592936,4.56776795 0.728909538,4.56630256 C0.709318833,4.56128119 0.690548483,4.55493221 0.672428396,4.54733956 C0.664434591,4.54401712 0.655649486,4.54000724 0.646986652,4.5356782 C0.632853581,4.52854177 0.619844851,4.52108146 0.607300097,4.51296522 C0.57983788,4.49532757 0.553546407,4.47359279 0.529687484,4.44820164 L0.580181353,4.49385001 C0.565377754,4.48250994 0.551357049,4.47019912 0.538214356,4.45701266 L0.529687484,4.44820164 C0.528511515,4.44695015 0.527344779,4.44569332 0.526187273,4.44443122 C0.511210281,4.42815798 0.497133965,4.41011417 0.484590646,4.3909753 C0.481678145,4.38656498 0.479087248,4.38244837 0.476575673,4.37829825 C0.469377348,4.36636993 0.462643071,4.35386276 0.45654871,4.34099343 C0.44539138,4.31736126 0.436735726,4.29342069 0.430333891,4.26902839 C0.421462527,4.2355423 0.416667928,4.1997701 0.416667928,4.16287807 L0.416667928,4.16287807 L0.416667928,1.66287807 C0.416667928,1.43275942 0.603215948,1.2462114 0.833334594,1.2462114 C1.06345324,1.2462114 1.25000126,1.43275942 1.25000126,1.66287807 L1.25000126,1.66287807 L1.24966667,3.19933333 Z",
  id: "path-1"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Master",
  stroke: "none",
  strokeWidth: 1.5,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "statses",
  transform: "translate(-42.000000, -407.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-Copy-2",
  transform: "translate(42.000000, 407.000000)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  fill: "currentColor",
  fillRule: "nonzero",
  cx: 8,
  cy: 8,
  r: 8
}), /*#__PURE__*/React.createElement("g", {
  id: "rotate-ccw",
  transform: "translate(3.000000, 3.000000)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-2",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-1"
})), /*#__PURE__*/React.createElement("use", {
  id: "Combined-Shape",
  fill: "#FFFFFF",
  xlinkHref: "#path-1"
})))));

var SvgReturned = function SvgReturned(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgReturned, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/returned.71d304f3.svg";
export { ForwardRef as ReactComponent };